export default __webpack_public_path__ + "static/media/Exercices.f92067f2.svg";